module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron bg-transparent text-center margin-none"
  }, [_c('h1', [_vm._v("本机配置")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-sm-offset-2"
  }, [_c('h4', {
    staticClass: "page-section-heading"
  }, [_vm._v("模板配置")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body buttons-spacing-vertical"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success btn-icon-stacked"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-arrow-circle-down"
  }), _vm._v(" "), _c('span', [_vm._v("load mould"), _c('br'), _vm._v("导入模板")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-icon-stacked"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-share-square-o"
  }), _vm._v(" "), _c('span', [_vm._v("export mould"), _c('br'), _vm._v("导出模板")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-icon-stacked"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-key "
  }), _vm._v(" "), _c('span', [_vm._v("key register"), _c('br'), _vm._v("产品注册")])])])])]), _vm._v(" "), _c('h4', {
    staticClass: "page-section-heading"
  }, [_vm._v("系统维护")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body buttons-spacing-vertical"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success btn-icon-stacked"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-arrow-circle-up"
  }), _vm._v(" "), _c('span', [_vm._v("system updata "), _c('br'), _vm._v("系统更新")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-icon-stacked"
  }, [_c('i', {
    staticClass: "fa fa-2x  fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("system setup"), _c('br'), _vm._v("开始安装")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-icon-stacked"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-refresh"
  }), _vm._v(" "), _c('span', [_vm._v("restore setting"), _c('br'), _vm._v("出厂恢复")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ef1e71d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Config.vue
// module id = 79
// module chunks = 0